<template>
  <nav v-if="items.length > 0" class="breadcrumbs">
    <template v-for="(item, index) in items" :key="index">
      <svg
        v-if="index > 0"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="breadcrumb-separator"
        aria-hidden="true"
      >
        <path d="m9 18 6-6-6-6"></path>
      </svg>
      <a
        v-if="item.url && (linkLastItem || index < items.length - 1)"
        :href="item.url"
        class="breadcrumb-link"
      >
        {{ item.label }}
      </a>
      <span v-else class="breadcrumb-current">{{ item.label }}</span>
    </template>
  </nav>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    required: true,
    validator: items => {
      return items.every(
        item =>
          typeof item === 'object' &&
          item !== null &&
          'label' in item &&
          (item.url === undefined || typeof item.url === 'string')
      )
    },
  },
  linkLastItem: {
    type: Boolean,
    default: false,
  },
})
</script>

<style scoped>
.breadcrumbs {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  line-height: 1.4;
  margin-bottom: 16px;
  padding: 8px 0;
  flex-wrap: wrap;
}

.breadcrumb-separator {
  width: 17px;
  height: 17px;
  color: #9ca3af;
  flex-shrink: 0;
}

.breadcrumb-link {
  color: #2aabee;
  text-decoration: none;
  transition: color 0.2s ease-in-out;
}

.breadcrumb-link:hover {
  color: #229ed9;
}

.breadcrumb-current {
  color: #111827;
  font-weight: 600;
}
</style>
